export class Pattern {
    public static readonly email = {
        pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+$/,
        message: 'Enter a valid email address to proceed.',
    };
    public static readonly mobile = { pattern: /^(?=.{10}$)\d\d*$/, message: 'Please enter a valid phone number.' };
    public static readonly alphaWithSpace = { pattern: /^[a-z\s]+$/i, message: 'Alphabets & space are allowed.' };
    public static readonly alphaWithSpaceDot = { pattern: /^([\s.]?[a-zA-Z]+)+$/, message: 'Alphabets, space & dots are allowed.' };
    public static readonly alphaNumeric = { pattern: /^[a-z\d]+$/i, message: 'Specialcharacter not allowed.' };
    public static readonly onlyAlpha = { pattern: /^[a-z]+$/, message: 'Only Alphabets are allowed.' };
    public static readonly onlyNumeric = { pattern: /^\d+$/i, message: 'Only Numbers are allowed.' };
    public static readonly atLeastOneupperCaseCharacter = { pattern: /[A-Z]/, message: 'Must contain an upper case Letter' };
    public static readonly atLeastOneLowerCaseCharacters = { pattern: /[a-z]/, message: 'Must contain an Lower case Letter' };
    public static readonly atLeastOneSpecialCharacters = { pattern: /[!@#$%^&*()\-_]/, message: 'Must contain a special character' };
    public static readonly Password_Pattern = {
        pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_])[A-Za-z\d!@#$%^&*()\-_]{8,}$/,
        message: 'Password is invalid',
    };
    public static readonly File_Name_Pattern = { pattern: /^[a-zA-Z0-9 _().-]+$/, message: 'Filename is invalid' };
}
